/*
  КОИ КАРТИ СЕ ВИЖДАТ ПРИ «ПРИ ВСЯКО ОТВАРЯНЕ» — решава се тук, не на сървъра.

  Кирил, 03.10: «стоят си едни и същи, ако ще и 20 refresh-а да направя».
  Сметката в Liquid работи само за заявка, която наистина стига до Shopify.
  Мерено: без бисквитки всяко отваряне дава друго, а със сесия — три различни
  от осем. Браузърът помни страницата и при рефреш често не пита сървъра.

  Затова сървърът рендира четири пъти повече карти, а изборът става тук — при
  всяко зареждане, включително когато страницата идва от кеш или от «назад».

  Излишните са скрити със стил, не махнати: лениви изображения в `display: none`
  не се теглят, а и връщането им е мигновено.
*/
(() => {
  const вземи = (списък, колко) => {
    // Разбъркване по Fisher–Yates: всяка подредба е еднакво вероятна. Простото
    // `sort(() => Math.random() - 0.5)` НЕ е честно — то клони към началния ред.
    const копие = списък.slice();
    for (let i = копие.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [копие[i], копие[j]] = [копие[j], копие[i]];
    }
    return копие.slice(0, колко);
  };

  const подреди = (кутия) => {
    const колко = parseInt(кутия.dataset.gmRoll, 10);
    if (!колко) return;
    const карти = [...кутия.children];
    if (карти.length <= колко) return;

    const избрани = new Set(вземи(карти, колко));
    // Редът на екрана остава редът на колекцията — разбърква се КОЕ се показва,
    // не в какъв ред. Иначе всяко зареждане разместваше и подредбата.
    карти.forEach((карта) => карта.classList.toggle('is-gm-spare', !избрани.has(карта)));
  };

  const всички = () => document.querySelectorAll('[data-gm-roll]').forEach(подреди);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', всички, { once: true });
  } else {
    всички();
  }

  // Връщане с «назад» сервира страницата от паметта на браузъра, без ново
  // зареждане — тогава `DOMContentLoaded` не се вдига и изборът щеше да е
  // същият, който човек току-що е видял.
  addEventListener('pageshow', (събитие) => {
    if (събитие.persisted) всички();
  });
})();
